import { GET_ADDITIONAL_FURNITURE_MASTER_LIST, INSERT_UPDATE_ADDITIONAL_FURNITURE_MASTER,DELETE_ADDITIONAL_FURNITURE_MASTER, GET_FURNITURE_SHELL_SCHEME_LIST, DELETE_INSERT_SHEEL_SCHEME } from "../../../../../utils/constants";


const initialState = [];

function additionalFurnitureMasterReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_ADDITIONAL_FURNITURE_MASTER_LIST:
            return [...state, payload];
        case INSERT_UPDATE_ADDITIONAL_FURNITURE_MASTER:
            return [...state, payload];
        case DELETE_ADDITIONAL_FURNITURE_MASTER:
            return [...state, payload];
        case GET_FURNITURE_SHELL_SCHEME_LIST:
            return [...state, payload];
        case DELETE_INSERT_SHEEL_SCHEME:
            return [...state, payload];

        default:
            return state;
    }
};

export default additionalFurnitureMasterReducer;